import { formatPercent } from 'app/lib/utils'

function formatDuration(value: number) {
  let seconds = Math.floor(value) % 60
  let minutes = Math.floor(value / 60) % 60
  return `${minutes}m ${seconds}s`
}

export default function MetricCell({
  value,
  type = `unitless`,
}: {
  value: number | undefined
  type?: `dollars` | `percentage` | `time` | `days` | `unitless`
}) {
  return (
    <>
      {typeof value === `undefined` || isNaN(value) || !isFinite(value)
        ? `-`
        : type === `dollars`
          ? `$${Math.floor(Number(value)).toLocaleString(`en-US`)}`
          : type === `percentage`
            ? `${formatPercent(value)}%`
            : type === `time`
              ? formatDuration(value)
              : type === `days`
                ? `${Math.floor(value)} day${Math.floor(value) !== 1 ? `s` : ``}`
                : Math.floor(value).toLocaleString(`en-US`)}
    </>
  )
}
